export default function ({ store, redirect, error, route }) {
  const logged = store.getters['authentication/logged']
  const isVendor = store.getters['authentication/isVendor']
  const isBroker = store.getters['authentication/isBroker']
  const isVendorAdmin = store.getters['authentication/isVendorAdmin']
  const vendorSuspended = store.getters['authentication/vendorSuspended']
  const hasOrders = store.getters['authentication/hasOrders']
  const hasSamples = store.getters['authentication/hasSamples']
  const vendorPermissionRoutes = store.getters['authentication/vendorPermissionRoutes']
  const addedBothBankAndCard = store.getters['authentication/addedBothBankAndCard']
  const showAllTabs = store.getters['authentication/showAllTabs']
  const onboarded = showAllTabs || addedBothBankAndCard

  if (!logged) {
    store.dispatch('authentication/logout')
    redirect({
      name: 'login',
      query: {
        to: route.fullPath
      }
    })

    return
  }

  if (!isVendor) return error({ status: 403 })

  if (vendorSuspended || !onboarded) {
    if (route.name.includes('vendors-settings')) return
    if (route.name.includes('vendors-orders') && hasOrders) return
    if (route.name.includes('vendors-samples') && hasSamples) return

    return error({ status: 403 })
  }

  if (isVendorAdmin || isBroker || route.name.includes('vendors-settings')) return

  if (vendorPermissionRoutes.every(e => !route.name.includes(e))) return error({ status: 403 })
}
